import React, { useState } from "react";
import { Box, Button, Typography, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import OtpComponent from "./Otp";

const ForgotPassword = () => {
  const [data, setData] = useState({ username: "", email: "", newPassword: "" });
  const [otp, setOtp] = useState("");
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    setFieldErrors({ ...fieldErrors, [e.target.name]: "" });
  };

  const validateFields = () => {
    const errors = {};
    if (!data.username.trim()) errors.username = "Username is required.";
    if (!data.email.trim()) {
      errors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = "Enter a valid email address.";
    }
    return errors;
  };

  const validatePassword = () => {
    if (!data.newPassword.trim()) return "Password is required.";
    if (data.newPassword.length < 6) return "Password must be at least 6 characters.";
    return "";
  };

  const handleSendOtp = async () => {
    const errors = validateFields();
    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    try {
      await axios.get(`${process.env.REACT_APP_BACKEND_URL}/auth/send-password-reset-otp?email=${data.email}`);
      setIsOtpModalOpen(true);
    } catch (error) {
      setError(error.response?.data?.Exception || "Failed to send OTP.");
    }
  };

  const handleChangePassword = async () => {
    const passwordError = validatePassword();
    if (passwordError) {
      setFieldErrors({ ...fieldErrors, newPassword: passwordError });
      return;
    }

    if (!otp.trim()) {
      setFieldErrors({ ...fieldErrors, otp: "OTP is required." });
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/verify-otp-and-submit-new-password`, {
        username: data.username,
        email: data.email,
        newPassword: data.newPassword,
        otp,
      });
      setIsOtpModalOpen(false);
      navigate("/");
    } catch (error) {
      setError(error.response?.data?.Exception || "Failed to reset password.");
    }
  };

  return (
    <Box className="parent-div">
      <div className="eclipse1"></div>
      <div className="eclipse2"></div>
      <Box
        sx={{
          padding: "20px 20px",
          zIndex: 100,
          position: "relative",
        }}
      >
        <Typography className="heading">Forgot Password</Typography>
        <Typography className="sub-heading">
          Enter your username and email id to change your password
        </Typography>
      </Box>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
        }}
        className="main-container"
      >
        <input
          type="text"
          name="username"
          id="username"
          placeholder="Mobile No"
          onChange={handleChange}
        />
        {fieldErrors.username && (
          <Typography sx={{ color: "red", fontSize: '12px', lineHeight: '0.1rem', marginLeft: '25px' }}>{fieldErrors.username}</Typography>
        )}

        <input
          type="email"
          name="email"
          id="email"
          placeholder="Email"
          onChange={handleChange}
        />
        {fieldErrors.email && (
          <Typography sx={{ color: "red", fontSize: '12px', lineHeight: '0.1rem', marginLeft: '25px' }}>{fieldErrors.email}</Typography>
        )}

        {error && <Typography sx={{ color: "red" }}>{error}</Typography>}
        <Typography textAlign={"center"}>
          Go to <a href="/">Sign In</a>
        </Typography>
        <Button variant="contained" onClick={handleSendOtp}>
          Submit
        </Button>
      </form>

      {/* OTP Modal */}
      <Modal open={isOtpModalOpen} onClose={() => setIsOtpModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 250,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
          }}
        >
          <Typography variant="h6" textAlign="center" mb={2}>
            Enter OTP
          </Typography>
          {/* <OtpComponent otp={otp} onOtpChange={setOtp} /> */}
          <input
            type="text"
            name="otp"
            id="otp"
            placeholder="OTP"
            onChange={(e) => setOtp(e.target.value)}
          />
          {fieldErrors.otp && (
            <Typography sx={{ color: "red", fontSize: '12px', lineHeight: '0.1rem', marginLeft: '25px' }}>
              {fieldErrors.otp}
            </Typography>
          )}

          <input
            type="password"
            name="newPassword"
            id="password"
            placeholder="New Password"
            onChange={handleChange}
          />
          {fieldErrors.newPassword && (
            <Typography sx={{ color: "red", fontSize: "0.8rem" }}>
              {fieldErrors.newPassword}
            </Typography>
          )}

          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 3 }}
            onClick={handleChangePassword}
          >
            Submit
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default ForgotPassword;